import React from 'react';
import { globalStoresContext, GlobalStoreType } from 'store/contexts';


export const useGlobalStores = (): GlobalStoreType => React.useContext(globalStoresContext);
